"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormWrapperButtons = exports.FormWrapperInputs = void 0;
var FormWrapperInputs;

(function (FormWrapperInputs) {
  FormWrapperInputs["Input"] = "Input";
  FormWrapperInputs["EmailInput"] = "EmailInput";
  FormWrapperInputs["IncrementDecrementInput"] = "IncrementDecrementInput";
  FormWrapperInputs["PhoneInput"] = "PhoneInput";
  FormWrapperInputs["SearchInput"] = "SearchInput";
  FormWrapperInputs["Checkbox"] = "Checkbox";
  FormWrapperInputs["FormWrapperSubmit"] = "FormWrapperSubmit";
  FormWrapperInputs["FormWrapperClear"] = "FormWrapperClear";
  FormWrapperInputs["GroupCheckbox"] = "GroupCheckbox";
  FormWrapperInputs["Dropdown"] = "Dropdown";
  FormWrapperInputs["Address"] = "Address";
  FormWrapperInputs["ToggleButton"] = "ToggleButton";
})(FormWrapperInputs || (exports.FormWrapperInputs = FormWrapperInputs = {}));

var FormWrapperButtons;

(function (FormWrapperButtons) {
  FormWrapperButtons["Submit"] = "FormWrapperSubmit";
  FormWrapperButtons["Clear"] = "FormWrapperClear";
})(FormWrapperButtons || (exports.FormWrapperButtons = FormWrapperButtons = {}));